var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',_vm._l((_vm.messages),function(message,i){return _c('li',{key:i},[_vm._v("\n          "+_vm._s(message)+"\n      ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }